import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { IoGift, IoClose, IoHeart } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { usePlumes } from './Plumes';
import './TipAuthor.css';

const TIP_OPTIONS = [
  { amount: 10, emoji: '🪶', label: 'Un merci' },
  { amount: 50, emoji: '☕', label: 'Un café' },
  { amount: 100, emoji: '📖', label: 'Un livre' },
  { amount: 500, emoji: '🎁', label: 'Un cadeau' },
];

export default function TipAuthor({ authorName, authorId }) {
  const [isOpen, setIsOpen] = useState(false);
  const [sent, setSent] = useState(false);
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState('');
  const { plumes, sendPlumesToAuthor } = usePlumes();
  const navigate = useNavigate();

  const canAffordAny = TIP_OPTIONS.some(tip => plumes >= tip.amount);

  const handleTip = async (tip) => {
    setError('');
    if (plumes < tip.amount) {
      setError('not_enough');
      return;
    }
    setSelected(tip);
    const success = await sendPlumesToAuthor(authorId, authorName, tip.amount);
    if (success) {
      setSent(true);
      setTimeout(() => {
        setSent(false);
        setIsOpen(false);
        setSelected(null);
      }, 3000);
    } else {
      setError('Erreur lors de l\'envoi. Réessaie.');
    }
  };

  return (
    <>
      <motion.button
        className="tip-trigger"
        onClick={() => setIsOpen(true)}
        whileTap={{ scale: 0.9 }}
      >
        <IoGift /> Soutenir l'auteur
      </motion.button>

      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              className="tip-backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => { setIsOpen(false); setSent(false); setError(''); }}
            />
            <motion.div
              className="tip-panel"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
            >
              {sent ? (
                <div className="tip-success">
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ type: 'spring' }}
                    className="tip-success-icon"
                  >
                    <IoHeart />
                  </motion.div>
                  <h3>Merci !</h3>
                  <p>Tu as envoyé {selected?.amount} 🪶 à {authorName} !</p>
                </div>
              ) : (
                <>
                  <div className="tip-header">
                    <h3>Soutenir {authorName}</h3>
                    <button className="tip-close" onClick={() => { setIsOpen(false); setError(''); }}><IoClose /></button>
                  </div>
                  <p className="tip-subtitle">Envoie des plumes pour montrer ton amour !</p>
                  <p className="tip-balance">Ton solde : <strong>{plumes.toLocaleString('fr-FR')} 🪶</strong></p>

                  {/* Pas assez de plumes — bouton achat */}
                  {(!canAffordAny || error === 'not_enough') && (
                    <div className="tip-buy-section">
                      <p className="tip-buy-text">
                        {plumes === 0 ? 'Tu n\'as pas encore de plumes' : `Pas assez de plumes (${plumes} 🪶)`}
                      </p>
                      <motion.button
                        className="tip-buy-link"
                        onClick={() => { setIsOpen(false); navigate('/profile'); }}
                        whileTap={{ scale: 0.95 }}
                      >
                        🪶 Acheter des plumes
                      </motion.button>
                    </div>
                  )}

                  {error && error !== 'not_enough' && (
                    <p className="tip-error">{error}</p>
                  )}

                  <div className="tip-amounts">
                    {TIP_OPTIONS.map(tip => (
                      <motion.button
                        key={tip.amount}
                        className={'tip-amount-btn ' + (plumes < tip.amount ? 'tip-amount-disabled' : '')}
                        onClick={() => handleTip(tip)}
                        whileTap={plumes >= tip.amount ? { scale: 0.95 } : {}}
                        whileHover={plumes >= tip.amount ? { y: -3 } : {}}
                      >
                        <span className="tip-emoji">{tip.emoji}</span>
                        <span className="tip-price">{tip.amount} 🪶</span>
                        <span className="tip-label">{tip.label}</span>
                      </motion.button>
                    ))}
                  </div>
                </>
              )}
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
}